import { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Col,
  Input,
  Badge,
} from "reactstrap";
import "../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import { clientmanageService } from "../../services/clientmanageService.js";
import { ToastContainer, toast } from "react-toastify";

const SmeTransitionV2Detail = () => {
  const history = useHistory();
  const params = useParams();
  const subClientId = params.sub_client_id;

  const [tasks, setTasks] = useState([]);
  const [clientName, setClientName] = useState("");
  const [subClientName, setSubClientName] = useState("");
  const [completionPct, setCompletionPct] = useState(0);
  const [disableState, setDisableState] = useState(false);

  useEffect(() => {
    loadDetail();
  }, []);

  function loadDetail() {
    clientmanageService
      .getTransitionV2Detail(subClientId)
      .then((response) => {
        if (response && response.status === 200) {
          setTasks(response.data.tasks);
          setClientName(response.data.client_name);
          setSubClientName(response.data.sub_client_name);
          setCompletionPct(response.data.completion_percentage);
        }
      });
  }

  function inputHandler(index, field, value) {
    const updated = [...tasks];
    updated[index] = { ...updated[index], [field]: value };
    setTasks(updated);
  }

  function saveData(e) {
    e.preventDefault();
    setDisableState(true);

    const payload = {
      sub_client_id: subClientId,
      tasks: tasks.map((t) => ({
        id: t.id,
        status: t.status,
        remarks: t.remarks || "",
      })),
    };

    clientmanageService
      .saveTransitionV2Detail(payload)
      .then((response) => {
        if (response && response.status === 200) {
          toast.success(response.data.message);
          loadDetail();
        } else {
          toast.error("Something went wrong!");
        }
        setDisableState(false);
      });
  }

  const getCompletionColor = () => {
    if (completionPct >= 100) return "success";
    if (completionPct > 0) return "warning";
    return "secondary";
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row className="mt-5">
          <div className="col" style={{ padding: "0%" }}>
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <Col xl="5">
                    <h3 className="mb-0">
                      {clientName} - {subClientName}
                    </h3>
                  </Col>
                  <Col xl="3" style={{ textAlign: "right" }}>
                    <Badge color={getCompletionColor()} style={{ fontSize: "14px", padding: "8px 16px" }}>
                      Completion: {completionPct}%
                    </Badge>
                  </Col>
                  <Col xl="2" style={{ textAlign: "right" }}>
                    <Button
                      className="btn-icon-clipboard"
                      type="button"
                      onClick={() =>
                        clientmanageService.exportTransitionV2Detail(subClientId)
                      }
                      style={{ textAlign: "center" }}
                      title="Export to Excel"
                    >
                      <i className="fas fa-download" style={{ fontSize: "14px" }}></i>{" "}
                      Export
                    </Button>
                  </Col>
                  <Col xl="2" style={{ textAlign: "right" }}>
                    <Button
                      color="secondary"
                      type="button"
                      onClick={() =>
                        history.push("/admin/sme-transition-v2")
                      }
                    >
                      Back to List
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col" className="whitespace">Sr No</th>
                    <th scope="col" className="whitespace">Section</th>
                    <th scope="col" className="whitespace">Task Name</th>
                    <th scope="col" className="whitespace">Description</th>
                    <th scope="col" className="whitespace">Status</th>
                    <th scope="col" className="whitespace">Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {tasks && tasks.length > 0 ? (
                    tasks.map((task, i) => (
                      <tr
                        key={task.id}
                        className={i % 2 === 0 ? "purple-row" : "orange-row"}
                      >
                        <td className="whitespace">{task.sr_no}</td>
                        <td className="whitespace" style={{
                          fontWeight: i === 0 || (i > 0 && tasks[i - 1].section_name !== task.section_name) ? "bold" : "normal"
                        }}>
                          {task.section_name}
                        </td>
                        <td className="whitespace">{task.task_name}</td>
                        <td className="whitespace">{task.description}</td>
                        <td className="whitespace">
                          <select
                            className="form-control"
                            value={task.status || "Not Started"}
                            onChange={(e) =>
                              inputHandler(i, "status", e.target.value)
                            }
                          >
                            <option value="Not Started">Not Started</option>
                            <option value="Pending">Pending</option>
                            <option value="WIP">WIP</option>
                            <option value="Closed">Closed</option>
                            <option value="NA">NA</option>
                          </select>
                        </td>
                        <td className="whitespace">
                          <Input
                            type="text"
                            placeholder="Remarks"
                            value={task.remarks || ""}
                            onChange={(e) =>
                              inputHandler(i, "remarks", e.target.value)
                            }
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6}>No Data Found!</td>
                    </tr>
                  )}
                </tbody>
              </Table>
              <br />
              {tasks && tasks.length > 0 && (
                <div style={{ padding: "0 20px 20px" }}>
                  <Button
                    color="primary"
                    type="button"
                    onClick={saveData}
                    disabled={disableState}
                  >
                    {disableState ? "Saving..." : "Save"}
                  </Button>
                </div>
              )}
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default SmeTransitionV2Detail;
